module.exports = __webpack_public_path__ + "img/logo.ed1601e.svg";